import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ApolloProvider } from '@apollo/client';

import { AuthProvider } from './contexts/auth-context';
import { OrganizationProvider } from './contexts/OrganizationContext';
import apolloClient from './layouts/overview/common/graphql';
import App from './app';

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <ApolloProvider client={apolloClient}>
          <OrganizationProvider>
            <Suspense fallback={null}>
              <App />
            </Suspense>
          </OrganizationProvider>
        </ApolloProvider>
      </AuthProvider>
    </BrowserRouter>
  </HelmetProvider>
);